import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useNavigationStatus(showStatus) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.statusMessage) return;
    showStatus(location.state.statusMessage);
    navigate(location.pathname, { replace: true });
  }, [location.state, navigate, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
